module.exports = __webpack_public_path__ + "static/img/cha2.8d97622.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/cha2.png
// module id = 92xg
// module chunks = 1